// /pages/FleetManagement/Trucks/CreateTruckPage.tsx

import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { useThemeColors } from '@/hooks/useThemeColors';
// ✅ Import the new TruckForm component
import { TruckForm } from '@/components/forms/TruckForm'; 

export default function CreateTruckPage() {
    const colors = useThemeColors();
    const navigate = useNavigate();
    
    // The success handler redirects back to the list page
    const handleSuccess = () => {
        navigate('/fleet-management/trucks');
    };

    // The cancel handler redirects back to the list page
    const handleCancel = () => {
        navigate('/fleet-management/trucks');
    };

    return (
        <AdminLayout>
            {/* The outer box pattern for full height and scrollability */}
            <Box p={4} h="100%" overflow="auto">
                <Card>
                    {/* Header Pattern */}
                    <CardHeader py={3}> 
                        <Heading size="md" mb={1}>
                            Create Truck
                        </Heading>
                        <Text fontSize="sm" color={colors.text}>
                            Add a new truck to the fleet.
                        </Text>
                    </CardHeader>
                    
                    {/* Body contains the form, matching the User pattern */}
                    <CardBody>
                        <TruckForm onSuccess={handleSuccess} onCancel={handleCancel} />
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
}

// /pages/FleetManagement/Trucks/CreateTruckPage.tsx

// import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react';
// import { useNavigate } from 'react-router-dom';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { useThemeColors } from '@/hooks/useThemeColors';
// import { TruckForm } from '@/components/forms/TruckForm'; 

// export default function CreateTruckPage() {
//     const colors = useThemeColors();
//     const navigate = useNavigate();
    
//     const handleSuccess = () => {
//         navigate('/fleet-management/trucks');
//     };

//     const handleCancel = () => {
//         navigate('/fleet-management/trucks');
//     };

//     return (
//         <AdminLayout>
//             {/* 1. Use h="full" and overflow="hidden" for the container */}
//             <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
                
//                 {/* 2. Make Card flex and full height */}
//                 <Card h="full" display="flex" flexDirection="column">
                    
//                     {/* 3. flexShrink={0} ensures the header stays visible */}
//                     <CardHeader flexShrink={0} py={3}> 
//                         <Heading size="md" mb={1}>
//                             Create Truck
//                         </Heading>
//                         <Text fontSize="sm" color={colors.text}>
//                             Add a new truck to the fleet.
//                         </Text>
//                     </CardHeader>
                    
//                     {/* 4. The Magic Sauce: overflowY="auto" and flex="1" on the Body */}
//                     <CardBody overflowY="auto" flex="1" minH={0}>
//                         <TruckForm onSuccess={handleSuccess} onCancel={handleCancel} />
//                     </CardBody>
//                 </Card>
//             </Box>
//         </AdminLayout>
//     );
// }